"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADDRESS_STATE_ALLOWED_CHARS = exports.ADDRESS_POSTAL_CODE_ALLOWED_CHARS = exports.ADDRESS_CITY_ALLOWED_CHARS = exports.ADDRESS_STATE_MAX_LENGTH = exports.ADDRESS_POSTAL_CODE_MAX_LENGTH = exports.ADDRESS_CITY_MAX_LENGTH = exports.defaultAddress = void 0;
const intl_1 = require("../../locale/intl");
const texts_1 = require("../../texts");
exports.defaultAddress = {
    sys_root: (0, intl_1.$t)(texts_1.addressFieldText.default_address),
    location_address: "100 Main Street",
    location_address2: "Suite 300",
    location_city: "Los Angeles",
    location_state: "California",
    location_zip: "90017",
    location_country: "United States",
    location_point: {
        type: "Point",
        coordinates: [-118.2431295, 34.0511755],
    },
};
exports.ADDRESS_CITY_MAX_LENGTH = 50;
exports.ADDRESS_POSTAL_CODE_MAX_LENGTH = 10;
exports.ADDRESS_STATE_MAX_LENGTH = 25;
exports.ADDRESS_CITY_ALLOWED_CHARS = /^[^\u2000-\u206F\u2E00-\u2E7F\u2116F!"#$%&()*+,./:;<=>?@[\]^_{|}~]+$/;
exports.ADDRESS_POSTAL_CODE_ALLOWED_CHARS = /^[^\u2000-\u206F\u2E00-\u2E7F\u2116F!"#$%&()*+,./:;<=>?@[\]^_{|}~]+$/;
exports.ADDRESS_STATE_ALLOWED_CHARS = /^[^\u2000-\u206F\u2E00-\u2E7F\u2116F!"#$%&()*+,./:;<=>?@[\]^_{|}~]+$/;
